import styled from 'styled-components'

const UsernameIconWrap = styled.div`
   display:flex;
`;

export default UsernameIconWrap;
